import EventBus from '../utils/event'

const GlobalEventBus = new EventBus('GlobalEventBus');

export { GlobalEventBus }